import React, { useState } from "react";
import { toast } from "react-toastify";
import Handler from "../../../Helpers/Handler";
import { formatDateTime, textCapitalize } from "../../../Helpers/Utils";
import { StatusPill } from "../../../Components/Needed";

// carVerify/bikeVerify both require hub AND deviceId to already be set
// (device registration comes first in the workflow), and require
// rejectionReason whenever status is "rejected".
const VehicleVerifyPanel = ({ vehicleType, vehicleId, vehicle, onSaved }) => {
    const canVerify = !!(vehicle?.hub && vehicle?.deviceId);
    const [rejectionReason, setRejectionReason] = useState("");
    const [showRejectBox, setShowRejectBox] = useState(false);
    const [saving, setSaving] = useState(false);

    const submit = async (status) => {
        if (status === vehicle?.verificationStatus) {
            toast.error("Already up to date");
            return;
        }
        if (status === "rejected" && !rejectionReason.trim()) {
            setShowRejectBox(true);
            toast.error("A rejection reason is required");
            return;
        }
        setSaving(true);
        const response = await Handler({
            method: "patch",
            url: `/admin/${vehicleType}/${vehicleId}/verify`,
            data: { status, ...(status === "rejected" ? { rejectionReason: rejectionReason.trim() } : {}) },
        });
        if (response?.success) {
            toast.success(response?.data?.message || `${textCapitalize(status)} successfully`);
            setShowRejectBox(false);
            setRejectionReason("");
            onSaved?.();
        } else {
            toast.error(textCapitalize(response?.data?.message || "Unable to update verification"));
        }
        setSaving(false);
    };

    if (!canVerify) {
        return <p className="text-muted mb-0">Register a hub and device before this {vehicleType} can be verified.</p>;
    }

    return (
        <div>
            <div className="d-flex align-items-center gap-2 mb-3">
                <span className="text-muted">Current status:</span>
                <StatusPill active={vehicle?.verificationStatus === "verified"} activeText="Verified" inactiveText={textCapitalize(vehicle?.verificationStatus || "pending")} />
            </div>
            {vehicle?.verificationStatus === "rejected" && vehicle?.rejectionReason ? (
                <p className="small text-muted">Last rejection reason: {vehicle.rejectionReason}</p>
            ) : null}
            {vehicle?.verifiedAt ? <p className="small text-muted">Verified {formatDateTime(vehicle.verifiedAt)}</p> : null}

            <div className="d-flex align-items-center gap-2 mb-2">
                <button type="button" className="btn btn-sm btn-success" onClick={() => submit("verified")} disabled={saving || vehicle?.verificationStatus === "verified"}>
                    {saving ? "Saving..." : "Mark verified"}
                </button>
                <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => setShowRejectBox(true)} disabled={saving}>
                    Reject
                </button>
            </div>
            {showRejectBox ? (
                <div className="d-flex align-items-center gap-2">
                    <input type="text" className="form-control" placeholder="Rejection reason" value={rejectionReason} onChange={(e) => setRejectionReason(e.target.value)} />
                    <button type="button" className="btn btn-sm btn-danger text-nowrap" onClick={() => submit("rejected")} disabled={saving}>
                        Confirm reject
                    </button>
                </div>
            ) : null}
        </div>
    );
};

export default VehicleVerifyPanel;
